import type React from 'react';

import { Separator } from '@change/ds-core-ui';

import { CampaignPhoto } from '../components/CampaignPhoto';
import { EndorsementsOverview } from '../components/EndorsementsOverview';
import { PageMeta } from '../components/PageMeta';
import { ProfileCardWrapper } from '../components/ProfileCardWrapper';
import { ResponseListWrapper } from '../components/ResponseListWrapper';
import { SapToDm } from '../components/SapToDm';
import { TargetedPetitionListWrapper } from '../components/TargetedPetitionListWrapper';
import { TopIssues } from '../components/TopIssues';
import { WebsitesContainer } from '../components/Websites';

import { useLayout } from './hooks/useLayout';

export const Layout: React.FC = () => {
	const {
		data: {
			showSapContainer,
			dmReputationLayer: { isDmrlEnabled, hasTopIssues, hasCampaignPhotoOrWebsites, hasEndorsements },
		},
	} = useLayout();

	return (
		<>
			<PageMeta />

			<div className="container pb-14">
				<ProfileCardWrapper />

				<div className="overflow-x-hidden px-4 md:px-0">
					<TargetedPetitionListWrapper />

					{showSapContainer && (
						<div className="mb-8">
							<SapToDm />
						</div>
					)}

					<ResponseListWrapper />

					{isDmrlEnabled && hasTopIssues && (
						<>
							<Separator orientation="horizontal" className="my-14" />
							<TopIssues />
						</>
					)}

					{isDmrlEnabled && hasEndorsements && (
						<>
							<Separator orientation="horizontal" className="my-14" />
							<EndorsementsOverview />
						</>
					)}

					{isDmrlEnabled && hasCampaignPhotoOrWebsites && (
						<>
							<Separator orientation="horizontal" className="my-14" />
							<div className="flex flex-col gap-14 md:flex-row">
								<CampaignPhoto />
								<WebsitesContainer />
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};
